module.exports = __webpack_public_path__ + "img/main_m.9ced11d.svg";